export default {
    reviews: 'ocjena',
    title: 'Rejting i ocjene proizvoda',
    resetFilters: 'Resetuj filtere',
    productComments: {
        title: 'Ocjene i komentari korisnika',
        seeAll: 'Pogledaj sve recenzije',
        postComment: 'Postavi komentar',
        comments: 'Komentari',
        hideComments: 'Sakrij',
        showComments: 'Prikaži komentare',
        button: {
            cancel: 'Otkaži',
            post: 'Postavi',
        }
    }
}
